import React from "react";
import theme from "src/theme";
import styled from "styled-components";

const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: auto;
  border-bottom: 1px solid ${theme.colors.white};

  &.border-top:first-child {
    border-top: 1px solid ${theme.colors.mediumGrey};
  }
`;

interface IProps {
  src: string;
  alt?: string;
  className?: string;
}

const RenderImage = ({ className, src, alt }: IProps): JSX.Element => {
  return <Image className={className} src={src} alt={alt} />;
};

export default RenderImage;
